import { createAsyncThunk } from '@reduxjs/toolkit';
import { storesApiService } from 'api/stores.api.service';

export const getStoresByState = createAsyncThunk(
  'by-state/get',
  (state: string) => storesApiService.getStoresByState(state),
);
